module.exports = __webpack_public_path__ + "img/single-post-img3-600x395.85748c9c.jpg";